<!-- <div class="background-unicamp"> -->
    <mat-card appearance="outlined">
      <app-logo></app-logo>

      @if(showMsg()){
      <mat-card-content>
        <div class="inscricao-info">
          <h2>{{ "login.titulo_inscricao" | translate }}</h2>
          <p>{{ "login.texto_inscricao_1" | translate }}</p>
          <p>
            <strong>{{ "login.nao_tem_conta_q" | translate }}</strong>
            {{ "login.clique_em" | translate }}
            <em>{{ "login.nao_tenho_cadastro" | translate }}</em>
            {{ "login.para_criar_perfil" | translate }}
          </p>
          <p>
            <strong>{{ "login.ja_tem_conta_q" | translate }}</strong>
            {{ "login.clique_em" | translate }}
            <em>{{ "login.ja_tenho_cadastro" | translate }}</em>
            {{ "login.faca_login_ficha" | translate }}
          </p>
          <p>
            {{ "login.dificuldade_inscricao" | translate }}
            <a href="mailto:secesp@unicamp.br">secesp@unicamp.br</a>.
          </p>
        </div>
      </mat-card-content>
      <br>
      }

      @if(!showLoginForm){

        <mat-card-content>
          <div class="escolha">
            <button matButton="filled" (click)="showLoginForm = true">
              <mat-icon>login</mat-icon> {{ "login.ja_tenho_cadastro" | translate }}
            </button>
            <button matButton="outlined" routerLink="/cadastro">
              <mat-icon>person_add</mat-icon> {{ "login.nao_tenho_cadastro" | translate }}
            </button>
          </div>
        </mat-card-content>
      }

      @if(showLoginForm){

      <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <mat-card-content>

          @if(email_precadastrado && formGroup.get('password')?.invalid){

            <div class="cadastrado-sucesso">
            <!-- <div class="cadastrado-sucesso"> -->
              {{ mensagem }}
            </div>
          }

          <div class="perfil">

            <small>Login: <b>{{ perfil.toUpperCase() }}</b></small>
          </div>
          <mat-form-field class="inputs" appearance="outline">
            <mat-label>{{ "login.email" | translate }}</mat-label>
            <input
              formControlName="username"
              type="email"
              email="true"
              matInput
              autofocus
            />
          </mat-form-field>

          <mat-form-field class="inputs" appearance="outline">
            <mat-label>{{ "login.senha" | translate }}</mat-label>
            <input #password formControlName="password" [type]="hidePassword ? 'text' : 'password'" matInput />
            <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
              [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>

          </mat-form-field>
        </mat-card-content>

        @if(formGroup.invalid){

          <div >
            @if(formGroup.hasError('invalidCredentials')){

              <small
                class="error_login"
                >{{ "login.falha_login" | translate}}
              </small>
            }
          </div>
        }

        <div class="cadastrese">
          <small class="text-mute">
            <a routerLink="/valida-email">{{ "login.esqueci_minha_senha" | translate}}</a>
          </small>
        </div>


        <mat-card-actions class="buttons">
          @if(this.perfil !== 'funcionario') {
            <button
              type="button"
              (click)="showLoginForm = false"
              matButton="outlined">
              <mat-icon>arrow_back</mat-icon> {{ "login.voltar" | translate }}
            </button>
          }
          <button
            [disabled]="formGroup.invalid || loading"
            type="submit"
            matButton="filled">
            <mat-icon>arrow_forward</mat-icon> {{ "login.entrar" | translate }}
          </button>
        </mat-card-actions>

        @if(this.perfil === 'aluno'){

          <div class="cadastrese">
            <small class="text-mute"
              >{{ "login.nao_possui_conta" | translate }}
              <a routerLink="/cadastro">{{ "login.clique_aqui" | translate }}</a>
            </small>
          </div>
        }
      </form>
      }
    </mat-card>

  @if (loading) {
    <div class="loader-overlay">
      <mat-spinner></mat-spinner>
    </div>
  }
<!-- </div> -->

